import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

export default class TaskCell extends Component {
  static propTypes = {
    isNew: PropTypes.bool,
    selectedElementId: PropTypes.string,
    callback: PropTypes.func,
    currentRowData: PropTypes.instanceOf(Map),
    rowIndex: PropTypes.number,
    handleAddRel: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
    };

    this._onClick = this._onClick.bind(this);
  }

  _onClick = () => {
    const { currentRowData, callback } = this.props;
    callback(currentRowData);
  }

  _addDependencyCallback = (e) => {
    const { handleAddRel, currentRowData, rowIndex } = this.props;
    e.stopPropagation();
    this.setState({ submitting: true });
    handleAddRel(currentRowData, rowIndex).then(() => {
      this.setState({ submitting: false });
    });
  };

  render() {
    const { currentRowData, selectedElementId } = this.props;
    if (currentRowData.get('title')) {
      const style = {
        paddingLeft: currentRowData.get('level', 0) * 25,
        fontWeight: 'bold',
        alignItems: 'center',
      };

      return (
        <div style={style} className="row wbs-header">
          <div>{currentRowData.get('title')}</div>
        </div>
      );
    }

    const spanStyle = {
      paddingLeft: currentRowData.get('level', 0) * 25,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    };
    const displayValue = currentRowData.get('name');

    const addDepButton =
      currentRowData.get('id') === selectedElementId ? null : (
        <button
          className="action-btn btn btn-success btn-xs"
          style={{ marginLeft: 10 }}
          onClick={this._addDependencyCallback}
          disabled={this.state.submitting}
        >
          <i className="fa fa-arrow-right" />
        </button>
      );

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <span className="wbs-element-title" style={spanStyle}>{displayValue}</span>
        {addDepButton}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/AssignPredecessorModal/TaskCell.js